import { gql } from '@apollo/client';

export const CREATE_DEALER = gql`
  mutation CreateDealer($createDealerInput: CreateDealerInput!) {
    createDealer(createDealerInput: $createDealerInput) {
      id
      name
      streetAddress
      city
      state
      zipCode
      certificateNumber
      certificateExpiresAt
      phone
      email
      website
      introduction
      createdAt
      updatedAt
      users {
        id
        email
        displayName
      }
      cars {
        id
        name
        weekdayPrice
        weekendPrice
        holidayPrice
        monthlyPrice
        monthlyRentalIsOn
        gas
        gearType
        thumbnailUrl
        year
        model
        make
        seats
        images {
          imageUrl
        }
        priceCalendar {
          date
          price
          isAvailable
        }
        productTypeDetails {
          id
          type
          saleAs
          hasInsurance
          taxable
        }
        vin
        sold
        soldAt
        currentLocation
        originalPrice
        isCreated
        licensePlate
        licensePlateState
        gasGrade
        cityMpg
        hwyMpg
        doors
        description
        discount {
          threeDays
          oneWeek
          twoWeeks
          threeWeeks
          oneMonth
          twoMonths
          threeMonths
          lastMinBooth
        }
        tripPreferences {
          advanceNoticeHours
          tripBufferHours
          shortestTripDays
          longestTripDays
        }
        distanceLimit {
          dailyDistanceLimit
          unlimitedMileage
        }
        location {
          id
          name
          address
          city
          state
          zipCode
          taxRate
        }
        owner {
          id
          email
          firstName
          lastName
          displayName
        }
        bookings {
          id
          startAt
          endAt
          guestId
          hostId
          pickupLocationId
          returnLocationId
          receipt {
            pricePerDay
            totalDays
            totalPrice
            extraMilages
            perExtraMileCost
            tripFee
            insurancePerDay
            insuranceByTrip
            subtotal
            paymentMethod
            taxRate
            tax
            balance
            last4digitOfCard
          }
          status
        }
        dailyTripFee
        createdAt
        ageLimit
      }

      sellingCars {
        id
        make
        model
        year
      }
      soldCars {
        id
        make
        model
        year
      }
    }
  }
`;
//   # Variables:
//   {
//     "createDealerInput": {
//       "name": "Example Dealer",
//       "streetAddress": "123 Main St",
//       "city": "San Francisco",
//       "state": "CA",
//       "zipCode": "94105",
//       "certificateNumber": "CERT123",
//       "certificateExpiresAt": "2025-12-31T23:59:59Z",
//       "phone": "415-555-0123",
//       "email": "contact@exampledealer.com",
//       "website": "https://exampledealer.com",
//       "introduction": "Premier auto dealer serving the Bay Area"
//       "userId": "user-uuid-here"
//     }
//   }

export const UPDATE_DEALER = gql`
  mutation UpdateDealer($updateDealerInput: UpdateDealerInput!) {
    updateDealer(updateDealerInput: $updateDealerInput) {
      id
      name
      streetAddress
      city
      state
      zipCode
      certificateNumber
      certificateExpiresAt
      phone
      email
      website
      introduction
      cars {
        id
        make
        model
        year
      }
      users {
        id
        email
        displayName
      }
      createdAt
      updatedAt
      sellingCars {
        id
        make
        model
        year
      }
      soldCars {
        id
        make
        model
        year
      }
    }
  }
`;
//   # Variables:
//   {
//     "updateDealerInput": {
//       "id": "dealer-uuid-here",
//       "name": "Updated Dealer Name",
//       "phone": "415-555-0124",
//       "email": "new@exampledealer.com"
//     }
//   }

export const GET_MY_DEALER = gql`
  query GetMyDealer {
    myDealer {
      id
      name
      streetAddress
      city
      state
      zipCode
      certificateNumber
      certificateExpiresAt
      phone
      email
      website
      introduction
      cars {
        id
        make
        model
        year
        vin
        listedSalePrice
        originalPrice
        isCreated
        licensePlate
        licensePlateState
        gasGrade
        cityMpg
        hwyMpg
        doors
        description
      }
      users {
        id
        email
        displayName
      }
      createdAt
      updatedAt
      sellingCars {
        id
        make
        model
        year
        vin
        listedSalePrice
        originalPrice
        isCreated
        licensePlate
        licensePlateState
        gasGrade
        cityMpg
        hwyMpg
        doors
        description
        images {
          imageUrl
        }
        thumbnailUrl
      }
      soldCars {
        id
        make
        model
        year
      }
    }
  }
`;

export const ADD_CAR_TO_DEALER = gql`
  mutation AddCarToSelling($input: AddCarToSellingInput!) {
    addCarToSelling(addCarToSellingInput: $input) {
      id
      name
      cars {
        id
        make
        model
        year
        status
        originalPrice
        listedSalePrice
      }
      sellingCars {
        id
        make
        model
        year
        status
        originalPrice
        listedSalePrice
      }
      soldCars {
        id
        make
        model
        year
        status
        listedSalePrice
        originalPrice
      }
    }
  }
`;

export const GET_UNLISTED_CARS_BY_USER_ID_FOR_DEALER = gql`
  query GetUnlistedCarsByUserIdForDealer {
    getUnlistedCarsByUserIdForDealer {
      id
      make
      model
      year
      vin
      listedSalePrice
      originalPrice
      isCreated
      licensePlate
      licensePlateState
      gasGrade
      cityMpg
      hwyMpg
      doors
      description
      images {
        imageUrl
      }
      thumbnailUrl
    }
  }
`;
